<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/member_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>會員專區</h1>
          <div class="banner-text-line"></div>
          <span>Members</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <!-- 活動報名頁面 -->
          <section class="detail">
            <div class="content-title">
              <h2>活動基本資訊</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                <router-link to="/member">
                  會員專區
                </router-link>
                <span>></span>
                活動繳費紀錄
              </div>
            </div>
            <div class="box">
              <div class="act">
                <div class="info">
                  <div class="img">
                    <img v-if="eventDetail.Picture" :src="eventDetail.Picture" :alt="eventDetail.Title" />
                    <img v-else src="../assets/images/continuing_pic.jpg" alt />
                  </div>
                  <div class="content fixed-body">
                    <div class="eventCard-date">
                      <div class="eventCard-date-month">
                        <div class="day">25</div>
                        <div class="month">JUN</div>
                      </div>
                      <div class="eventCard-date-year">2020</div>
                      <!-- <div class="eventCard-detail-tag orange">會員大會</div> -->
                    </div>
                    <div class="title">{{ eventDetail.Title }}</div>
                    <ul class="organize-list list-unstyled">
                      <!-- <li>活動編號：12345678</li> -->
                      <!-- <li v-if="eventDetail.Organizer">活動單位：{{eventDetail.Organizer}}</li> -->
                      <!-- <li>服務專線：0912-345678</li> -->
                    </ul>
                    <ul class="text list-unstyled">
                      <!-- <li>中華民國視網膜醫學會</li>
                      <li>服務專線:0965-106869</li>-->
                      <li>
                        <div class="li-title">
                          <div class="li-img">
                            <img
                              src="../assets/images/icon/calendar_orange.png"
                              alt="活動日期"
                            />
                          </div>
                          活動日期:
                        </div>
                        <div class="li-content">
                          {{
                            $moment(eventDetail.StartOn)
                              .locale("zh-tw")
                              .format("YYYY.MM.DD")
                          }}
                        </div>
                      </li>
                      <li v-if="eventDetail.Location">
                        <div class="li-title">
                          <div class="li-img">
                            <img
                              src="../assets/images/icon/pin_orange.png"
                              alt="活動地點"
                            />
                          </div>
                          活動地點:
                        </div>
                        <div class="li-content">{{ eventDetail.Location }}</div>
                      </li>
                      <li>
                        <div class="li-title">
                          <div class="li-img">
                            <img
                              src="../assets/images/icon/hands_orange.png"
                              alt="主辦單位"
                            />
                          </div>
                          主辦單位:
                        </div>
                        <div class="li-content">
                          {{
                            eventDetail.Organizer ? eventDetail.Organizer : "無"
                          }}
                        </div>
                      </li>
                      <!-- <li>協辦單位 : {{eventDetail.CoOrganizer ? eventDetail.CoOrganizer:'無'}}</li> -->
                    </ul>
                    <div class="newsCard-content-detail fixed-content">
                        <a href="#" @click.prevent="goDetail(JoinEvent.ActivityId)"
                          >查看詳情</a
                        >
                      </div>
                  </div>
                </div>
              </div>
              <div class="content-title">
                <h2>報名人資訊</h2>
              </div>
              <div class="content-contact">
                <div class="member">
                  <div class="input_span">
                    <span>中文姓名</span>
                    <span class="payed-content">{{JoinEvent.Name}}</span>
                    <!-- <input
                      type="text"
                      placeholder="輸入中文姓名"
                      required
                      v-model="JoinEvent.Name"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>英文姓名</span>
                    <span class="payed-content">{{JoinEvent.EngName}}</span>
                    <!-- <input
                      type="text"
                      placeholder="輸入英文姓名"
                      required
                      v-model="JoinEvent.EngName"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>聯絡電話</span>
                    <span class="payed-content">{{JoinEvent.Mobile}}</span>
                    <!-- <input
                      type="text"
                      placeholder="請輸入連絡電話"
                      required
                      v-model="JoinEvent.Mobile"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>E-mail</span>
                    <span class="payed-content">{{JoinEvent.Email}}</span>
                    <!-- <input
                      type="email"
                      placeholder="請輸入電子郵件"
                      required
                      v-model="JoinEvent.Email"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>服務單位</span>
                    <span class="payed-content">{{JoinEvent.Affiliation}}</span>
                    <!-- <input
                      type="text"
                      placeholder="請輸入服務單位"
                      required
                      v-model="JoinEvent.Affiliation"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>職稱</span>
                    <span class="payed-content">{{JoinEvent.Position}}</span>
                    <!-- <input
                      type="text"
                      placeholder="請輸入職稱"
                      required
                      v-model="JoinEvent.Position"
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>稱謂</span>
                    <span class="payed-content">{{JoinEvent.Title}}</span>
                    <!-- <select v-model="JoinEvent.Title">
                      <option value="null" disabled>請選擇稱謂</option>
                      <option value="醫師">醫師</option>
                      <option value="研究生">研究生</option>
                      <option value="親友">親友</option>
                    </select> -->
                  </div>
                  <div class="input_span">
                    <span>葷素類別</span>
                    <span class="payed-content">{{JoinEvent.IsVegetarian?"素":"葷"}}</span>
                    <!-- <select v-model="JoinEvent.IsVegetarian">
                      <option value="false">葷</option>
                      <option value="true">素</option>
                    </select> -->
                  </div>
                  <div class="input_span">
                    <span>晚宴</span>
                    <span class="payed-content">{{JoinEvent.IsAttendDinner?"參加":"不參加"}}</span>
                    <!-- <select v-model="JoinEvent.IsAttendDinner">
                      <option value="true">參加</option>
                      <option value="false">不參加</option>
                    </select> -->
                  </div>
                </div>
              </div>

              <div class="content-title activity">
                <h2>隨行親友</h2>
                <span>總人數 : {{ JoinEvent.Companions.length }}</span>
              </div>
              <div class="friend">
                <div
                  class="item animated fadeIn"
                  v-for="(friend, index) in JoinEvent.Companions"
                  :key="index"
                >
                  <div class="title">
                    <span>隨行親友{{ index + 1 }}</span>
                    <!-- <span @click="removeFriend(index)">×</span> -->
                  </div>
                  <div class="input_span">
                    <span>中文姓名</span>
                    <span class="payed-content">{{friend.Name}}</span>
                    <!-- <input
                      type="text"
                      v-model="friend.Name"
                      placeholder="請輸入中文姓名"
                      required
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>英文姓名</span>
                    <span class="payed-content">{{friend.EngName}}</span>
                    <!-- <input
                      type="text"
                      v-model="friend.EngName"
                      placeholder="請輸入英文姓名"
                      required
                    /> -->
                  </div>
                  <div class="input_span">
                    <span>稱謂</span>
                    <span class="payed-content">{{friend.Title}}</span>
                    <!-- <select v-model="friend.Title">
                      <option value="null" disabled>請選擇稱謂</option>
                      <option value="醫師">醫師</option>
                      <option value="研究生">研究生</option>
                    </select> -->
                  </div>
                  <div class="input_span">
                    <span>葷素類別</span>
                    <span class="payed-content">{{friend.IsVegetarian?"素":"葷"}}</span>
                    <!-- <select v-model="friend.IsVegetarian">
                      <option value="false">葷</option>
                      <option value="true">素</option>
                    </select> -->
                  </div>
                  <div class="input_span">
                    <span>晚宴</span>
                    <span class="payed-content">{{friend.IsAttendDinner?"參加":"不參加"}}</span>
                    <!-- <select v-model="friend.IsAttendDinner">
                      <option value="true">是</option>
                      <option value="false">否</option>
                    </select> -->
                  </div>
                </div>
              </div>
              <div class="content-title" v-if="eventDetail.RequirePayment">
                <h2>報名費</h2>
              </div>
              <div class="cost-container">
                <div class="cost" v-if="eventDetail.RequirePayment">
                  <!-- <div class="title" :class="{'isMember':IsEarly}">{{PriceType.Title}}</div> -->
                  <div class="title" :class="{ isMember: true }">
                    {{ PriceType.Title }}
                  </div>
                  <ul class="signtpye">
                    <li>
                      <span>{{ payName }}</span>
                      <span>NTD {{ paySelf }}</span>
                    </li>
                    <li v-if="JoinEvent.Companions.length > 0">
                      <span>隨同親友及其他({{ JoinEvent.Companions.length }}名)</span>
                      <span>NTD {{ Friendprice * JoinEvent.Companions.length }}</span>
                    </li>
                  </ul>
                </div>
                <div
                  class="global_title nomb"
                  v-if="eventDetail.RequirePayment"
                ></div>
                <div class="total" v-if="eventDetail.RequirePayment">
                  <span>小計</span>
                  <span>NTD {{ paySelf + Friendprice * JoinEvent.Companions.length }}</span>
                </div>
              </div>
            </div>
            <!-- <graybtn :url="`/Event/Index?Id=${isDetail}`" name="回上一頁"></graybtn> -->
          </section>
          <div class="contact-back">
              <a href="#" @click.prevent="toList">
                回列表
                <img src="../assets/images/icon/back_icon.png" alt="回列表" />
              </a>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery';
// import Common from '@/common';
import API from '@/assets/api/member';
import Common from '@/common';
import BG from '../assets/images/index_bg_big.png';

export default {
  components: {
  },
  data() {
    return {
      BG,
      activityDetail: {
        Id: '5d5d4a9b-f19a-474e-90c3-c8ee87c0d359',
        Title: '艾利根論文獎甄選活動!!',
        // eslint-disable-next-line global-require
        Image: require('@/assets/images/continuing_pic.jpg'),
        StartOn: '2019-07-11T00:00:00',
        EndOn: '2019-08-17T00:00:00',
        DocumentFile:
          'https://retinasociety.blob.core.windows.net/submission/eeb70bfb-ea96-4fb9-8957-59ec9131cf68/9a66c81ffdd24878b9821af506da5f22.doc',
        Content: `   <p>親愛的會員您好:</p>
              <p>
                今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
                <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
              </p>
              <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
              <ul>
                <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
                <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
                <li>
                  (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
                  <span
                    style="backgroundColor:#ff0;"
                  >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
                </li>
                <li>
                  (四) 敬請各位會員於
                  <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
                </li>
              </ul>
              <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
              <p>
                相關投稿事項請至IOIS網站:
                <a
                  href="https://www.iois.info/page.php?edi_id=1463"
                >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
              </p>
              <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
              <p>中華民國視網膜醫學會 陳世真 理事長</p>
              <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
              <p>許淑娟 會長 敬邀</p>`,
      },
      eventDetail: {},
      JoinEvent: {
        // Title: '醫師',
        // Name: '測試',
        // EngName: 'test',
        // Telephone: '',
        // Mobile: '0912-345678',
        // Email: 'abc@abc.com',
        // Affiliation: 'OO大學',
        // Position: '主治醫生',
        // ZipCode: '',
        // Address: '',
        // SelectedFee: 0, // 0會員 1專科醫師 2住院醫師、研究醫師、學生
        // IsVegetarian: false,
        // IsAttendDinner: true,
        // MemberId: '',
        // ActivityId: '',
        // Companions: [
        //   // {
        //   //   Name: '親友一',
        //   //   EngName: 'friend1',
        //   //   Title: '研究生',
        //   //   IsVegetarian: false,
        //   //   IsAttendDinner: true,
        //   // },
        //   // {
        //   //   Name: '親友2',
        //   //   EngName: 'friend2',
        //   //   Title: '研究生',
        //   //   IsVegetarian: false,
        //   //   IsAttendDinner: true,
        //   // },
        // ],
      },
      payName: '學會會員',
      paySelf: 0,
      isLogin: false,
      token: '',
    };
  },
  methods: {
    getPlanID(id) {
      const vm = this;
      vm.$store.commit('FROM', 'activity');
      vm.$router.push(`/plan/planId/${id}`);
    },
    toList() {
      const vm = this;
      vm.$router.push({
        name: 'member',
        params: { data: 'payedDetail' },
        // query: { data: 'admission' },
      });
    },
    goDetail(id) {
      const vm = this;
      vm.$router.push(`/activity/${id}`);
    },
    getOderDetail(id) {
      const vm = this;
      API.ActivityQrderDetail(id, vm.token).then((res) => {
        if (res.status === 200) {
          vm.eventDetail = res.data.Data;
          vm.JoinEvent = res.data.Data.Participant.Value;
        }
        // console.log(res);
      });
    },
  },
  created() {
    const vm = this;
    vm.eventDetail = {
      CategoryId: '3490aec0-8144-46d9-ad99-3d69b7dc63a5',
      CoOrganizer: '台北榮民總醫院蘇澳分院',
      Content:
        '<span style="font-family:Arial;"><span style="font-size:13.3333px;">test</span></span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span>',
      Description: '',
      DocumentFile: '',
      EndOn: '2019-10-30T00:00:00',
      FeeItems: [
        {
          Companion: 10,
          EndOn: '2020-09-30T16:26:45',
          Internship: 10,
          Membership: 100,
          Specialist: 100,
          StartOn: '2020-09-16T16:26:45',
          Title: '早鳥價',
        },
        {
          Companion: 100,
          EndOn: '2020-10-30T16:26:45',
          Internship: 102,
          Membership: 1002,
          Specialist: 1002,
          StartOn: '2020-10-01T00:00:00',
          Title: '一般價',
        },
      ],
      Id: 'a981b63d-7048-4410-8c82-139a117364eb',
      // eslint-disable-next-line global-require
      Image: require('@/assets/images/activity_pic_big.jpg'),
      Introduction: 'testtesttesttesttesttesttesttesttesttest',
      Location: '宜蘭老爺行旅',
      Organizer: 'test',
      RegisterEndOn: '2019-09-30T00:00:00',
      RegisterStartOn: '2019-09-16T00:00:00',
      RequirePayment: true,
      RequireRegister: true,
      StartOn: '2019-09-16T00:00:00',
      Title: 'testtest*-helen',
    };
    vm.paySelf = vm.FeeItems[0].Membership;
    vm.token = Common.getCookie('token');
    // console.log(vm.$route.params.payedId);
    vm.getOderDetail(vm.$route.params.payedId);
    // console.log(vm.PriceType, vm.FeeItems);
  },
  computed: {
    FeeItems() {
      const vm = this;
      const Arr = vm.eventDetail.FeeItems.map((item, index) => {
        item.Id = index;
        return item;
      });
      return Arr;
    },
    // EarlyDate() {
    //   const vm = this;
    //   return vm.$moment(vm.FeeItems[0].EndOn).format('YYYY-MM-DD');
    // },
    // JoinStartDate() {
    //   const vm = this;
    //   // console.log(vm.FeeItems);
    //   if (vm.eventDetail.RequirePayment) {
    //     // console.log(vm.FeeItems[0].StartOn);
    //     return vm.$moment(vm.FeeItems[0].StartOn).format('YYYY-MM-DD');
    //   }
    //   // console.log(vm.eventDetail.RegisterStartOn);
    //   return vm.$moment(vm.eventDetail.RegisterStartOn).format('YYYY-MM-DD');
    // },
    // JoinEndDate() {
    //   const vm = this;
    //   if (vm.eventDetail.RequirePayment) {
    //     const last = vm.FeeItems.length - 1;
    //     return vm.$moment(vm.FeeItems[last].EndOn).format('YYYY-MM-DD');
    //   }
    //   return vm.$moment(vm.eventDetail.RegisterEndOn).format('YYYY-MM-DD');
    // },
    Friendprice() {
      const vm = this;
      return vm.FeeItems[0].Companion;
    },
    // // 判斷有沒有早鳥
    // IsEarly() {
    //   const vm = this;
    //   const Early = vm.$moment(vm.FeeItems[0].EndOn).valueOf();
    //   const Now = vm.$moment().valueOf();
    //   if (Early > Now) {
    //     return true;
    //   }
    //   return false;
    // },
    PriceType() {
      const vm = this;
      const Now = vm.$moment().valueOf();
      const Type = '';
      const FeeSort = vm.FeeItems.sort((a, b) => (vm.$moment(a.EndOn).valueOf() > vm.$moment(b.EndOn).valueOf() ? 1 : -1)).filter(
        (fee) => vm.$moment(fee.EndOn).valueOf() > vm.$moment().valueOf(),
      );
      return FeeSort[0];
    },
    fromPath() {
      return this.$store.getters.from;
    },
  },
};
</script>

<style lang="scss" scoped>
.eventCard-date {
  display: flex;
  align-items: center;
  color: #001139;
  transition: all 0.5s;
  margin-right: 1.75rem;
  margin-bottom: 1.5rem;
}

.eventCard-date-month {
  line-height: 1;
  .day {
    font-size: 2.75rem;
    line-height: 1;
  }

  .month {
    font-size: 1.5rem;
  }
}

.eventCard-date-year {
  writing-mode: vertical-lr;
  font-size: 1.75rem;
  line-height: 1;
  margin-right: 1rem;

  // @media (max-width: 1024px) {
  //   margin-right: 1rem;
  // }
}

.eventCard-detail-tag {
  margin-bottom: 0;
}

.info {
  display: flex;
  padding: 1.5rem 0;

  @media (max-width: 1024px) {
    justify-content: center;
  }

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
  }

  //   @media (max-width: 768px) {
  //   flex-direction: column;
  // }

  .img {
    width: 50%;
    @media (max-width: 1024px) {
      display: flex;
      align-items: center;
      width: 60%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }

    @media (max-width: 420px) {
      width: 100%;
    }
    img {
      width: 100%;
    }
  }
  .content {
    padding: 1.5rem 2rem;
  }
}

.title {
  font-size: 1.5rem;
  color: #001139;
  margin-bottom: 1.5rem;
}

.text {
  margin-bottom: 0;
  li {
    display: flex;
    margin-bottom: 0.5rem;

    @media (max-width: 1024px) {
      flex-direction: column;
      margin-bottom: 1rem;
    }
    @media (max-width: 420px) {
      flex-direction: row;
    }
  }
}

.li-title {
  display: flex;
  color: #f68e56;
  margin-right: 0.8rem;
  width: 120px;
  flex: none;
}

.li-img {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  img {
    max-width: 100%;
  }
}

.li-content {
  color: #676767;
}

.member {
  width: 100%;
}

.input_span {
  input {
    width: calc(100% - 190px);
    color: #001139;

    @media (max-width: 420px) {
      width: 100%;
    }
  }

  select {
    width: 40%;
    padding: 2px 20px;
    @media (max-width: 420px) {
      width: 100%;
    }
  }
}

.content-title {
  &.activity {
    justify-content: flex-start;
    align-items: flex-end;

    h2 {
      margin-right: 10px;
    }

    span {
      margin-right: 5px;
      margin-bottom: 5px;
    }

    button {
      color: #fff;
      outline: none;
      border: unset;
      border-radius: 5px;
      background-color: #001139;
      margin-bottom: 5px;
    }
  }
}

.friend {
  padding: 30px 100px;
  @media (max-width: 1024px) {
    padding: 30px;
  }
  .item {
    padding: 30px 95px;
    border: 1px solid #959595;
    margin-bottom: 1.5rem;

    @media (max-width: 420px) {
      padding: 5px;
    }

    .title {
      display: flex;
      justify-content: space-between;
      span:last-child {
        cursor: pointer;
      }
    }
  }
}

.cost .signtpye {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-inline-start: 0;
}
.box .cost .signtpye li {
  padding: 8px 16px;
  display: flex;
  font-size: 1.3rem;
}
.box .cost .signtpye li > span:nth-child(1) {
  margin-right: 16px;
  color: #666;
}
.box .cost .signtpye li > span:nth-child(2),
.box .total > span:nth-child(2) {
  min-width: 110px;
  text-align: right;
}

.cost-container {
  padding: 30px 195px;
  @media (max-width: 1024px) {
    padding: 30px;
  }
  @media (max-width: 420px) {
    padding: 10px;
  }

  .title {
    text-align: right;
    padding: 10px 10px;

    &.isMember {
      background-color: #f68e56;
      color: #fff;
      font-size: 1.3rem;
    }
  }
  .input_span {
    // 讓下拉選單文字靠右
    select {
      width: 100%;
      text-align: right;
      text-align-last: right;
      color: #666;

      option {
        direction: rtl;
      }
    }
  }
}

.global_title {
  width: 100%;
  padding: 8px 16px;
  border-bottom: 1px solid #696969;
  font-size: 1.4rem;
  margin-bottom: 10px;
}

.detail .box .total {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
  color: #c0272d;
  font-size: 1.3rem;
}
.detail .box .total span:nth-child(1) {
  margin-right: 16px;
}

.btn-block {
  &.activity {
    text-align: center;
    padding-top: 2rem;
  }
}
.upload-block {
  .input_span {
    justify-content: center;
  }
}

.input_span {
  .fileArea {
    label {
      display: block;
      padding: 5px 24px;
      background-color: #f68e56;
      color: #fff;
      cursor: pointer;
    }
    input[type="file"] {
      padding: 2px 20px;
      width: 100%;
      display: none;
    }
  }
}

#popup .bg .content .delete span {
  padding: 0;
  width: unset;
  margin-right: 0;
  cursor: pointer;
}

.file_name {
  input[type="text"] {
    width: 100%;
  }
}

.popupPayType0 {
  @media (max-width: 420px) {
    padding-top: 100px;
  }
  @media (max-width: 375px) {
    padding-top: 250px;
  }
  @media (max-width: 320px) {
    padding-top: 450px;
  }
}

.popupPayType1 {
  @media (max-width: 360px) {
    padding-top: 150px;
  }
  @media (max-width: 320px) {
    padding-top: 300px;
  }
}

.popupPayTypeSuccess {
  @media (max-width: 360px) {
    padding-top: 100px;
  }
  @media (max-width: 320px) {
    padding-top: 200px;
  }
}

.activityDetail-title-text {
  .eventCard-detail-tag {
    @media (max-width: 420px) {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
  }
}

.organize-list {
  color: #676767;
  margin-bottom: 1rem;
}

.input_span span.payed-content {
  text-align: left;
  margin-right: 0;
  width: unset;
}

.fixed-body {
  position: relative;
  width: 50%;

  @media (max-width: 420px) {
      width: 100%;
  }

  .fixed-content {
    position: absolute;
    bottom: 0;
    right: 10%;
  }
}
</style>
